import { FONT_SIZE_EXTRA_SMALL } from "constants/constants";
import styled from "styled-components/macro";
import { Tooltip } from "@mui/material";

import { useAtom } from "jotai";
import { allAskrConfigsAtom } from "./FetchAllAskrConfigs";
import { NotificationsActive, Rule } from "@mui/icons-material";
import { useMemo } from "react";
import {
  TOOLTIP_PROPS,
  customerTilesPopupDataAtom,
} from "./internalToolsUtils";

const AskrConfigStyles = styled.div<{
  $numAlerts: number;
}>`
  cursor: pointer;

  width: fit-content;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  bottom: 0px;
  right: 0px;
  left: auto;
  font-size: ${FONT_SIZE_EXTRA_SMALL}px;
  color: hsl(0, 0%, 50%);
  .groupsAndProcesses {
    padding-right: 3px;
    padding-bottom: 3px;
    .MuiSvgIcon-root {
    }
  }
  .groupsAndProcesses,
  .numADLRules,
  .numAlerts {
    display: flex;
    align-items: center;
    height: 100%;
  }
  .numADLRules,
  .numAlerts {
    background: rgba(255, 255, 255, 0.8);
  }
  .numAlerts {
    padding-right: 1px;
  }
  .MuiSvgIcon-root {
    margin-left: 0.1em;
    margin-right: 0.1em;
    width: 0.45em;
    height: 0.45em;
  }
  .btnSearch .MuiSvgIcon-root {
    margin: 0;
  }
  &:hover {
    transition: all 0.2s ease;
    transform: scale(1.05);
    transform-origin: bottom right;
    box-shadow: -1px -1px 2px rgba(0, 0, 0, 0.12);
  }
`;

export default function AskrConfigIndicator({ ckey }: { ckey: string }) {
  // grab customer info & machemetry data from LS
  // if it's not there, query for it and store it there

  const [askrConfigs] = useAtom(allAskrConfigsAtom);
  const askrConfig = askrConfigs?.[ckey];

  const { adlRules, alertRules } = useMemo(() => {
    const adlRuleConfig = askrConfig?.adlRuleConfig;
    const alertRuleConfig = askrConfig?.alertRuleConfig;
    let adlRules = [];
    let alertRules = [];
    try {
      if (adlRuleConfig) {
        adlRules = JSON.parse(adlRuleConfig)?.rules;
      }
    } catch (error) {
      console.error("Error parsing askrConfig.adlRuleConfig", error);
    }
    try {
      if (alertRuleConfig) {
        alertRules = JSON.parse(alertRuleConfig)?.rules;
      }
    } catch (error) {
      console.error("Error parsing askrConfig.alertRuleConfig", error);
    }
    return { adlRules, alertRules };
  }, [askrConfig]);

  const numADLRules = adlRules?.length ?? 0;
  const numAlerts = alertRules?.length ?? 0;

  const [, setCustomerTilesPopupData] = useAtom(customerTilesPopupDataAtom);

  return askrConfig && (numADLRules > 0 || numAlerts > 0) ? (
    <AskrConfigStyles
      {...{ $numAlerts: numAlerts }}
      onClick={e => {
        e.stopPropagation();
        setCustomerTilesPopupData({
          ckey,
          popupData: {
            askrConfig: {
              adlRuleConfig: adlRules,
              alertRuleConfig: alertRules,
            },
          },
          adminUrls: [
            {
              url: `https://${ckey}.gke-us-east1.raven-cloud.com/midgard/admin/deployment_config/askrconfig/`,
              name: "Askr Config",
            },
          ],
        });
      }}
    >
      <Tooltip
        title={`🔍 ${numADLRules} ADL rule${
          numADLRules === 1 ? "" : "s"
        }, ${numAlerts} alert${numAlerts === 1 ? "" : "s"}`}
        {...TOOLTIP_PROPS}
      >
        <div className="groupsAndProcesses">
          <div className="numADLRules">
            <Rule /> {numADLRules}
          </div>
          <div className="numAlerts">
            <NotificationsActive /> {numAlerts}
          </div>
        </div>
      </Tooltip>
    </AskrConfigStyles>
  ) : null;
}
